import Autolinker from 'autolinker';

const autolinker = text => Autolinker.link(text);

export default autolinker;
